module.exports = __webpack_public_path__ + "static/media/Customized Wheat Flour (RED).0948e594.png";